(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-homelocation-selfservice.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-homelocation-selfservice.js');
"use strict";

const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const selfServiceCantShowHomeLocDialog = svs.lyckoplatsen.components.page_play.utils.selfServiceCantShowHomeLocDialog;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_draws.jotai.atoms,
  primaryDrawAtom = _svs$lyckoplatsen$com.primaryDrawAtom,
  secondaryDrawAtom = _svs$lyckoplatsen$com.secondaryDrawAtom,
  firstDrawAtom = _svs$lyckoplatsen$com.firstDrawAtom,
  lastDrawAtom = _svs$lyckoplatsen$com.lastDrawAtom;
const charityAtom = svs.lyckoplatsen.shared_charity.jotai.atoms.charityAtom;
const makePayment = svs.tur.pay_lyckoplatsen.makePayment;
const CONSTANTS = svs.lyckoplatsen.components.shared_constants.CONSTANTS;
const getDefaultLocationName = svs.tur.lyckoplatsen.utils.getDefaultLocationName;
const useHomeLocationSelfService = () => {
  const useResetPlayAtoms = svs.lyckoplatsen.components.page_play.react.hooks.useResetPlayAtoms;
  const primaryDraw = useAtomValue(primaryDrawAtom);
  const secondaryDraw = useAtomValue(secondaryDrawAtom);
  const charity = useAtomValue(charityAtom);
  const firstDraw = useAtomValue(firstDrawAtom);
  const lastDraw = useAtomValue(lastDrawAtom);
  const resetPlayAtom = useResetPlayAtoms();
  const handler = async () => {
    const price = CONSTANTS.PRICE_PER_WEEK * CONSTANTS.DRAWS.NUMBER_OF_WEEKS;
    const addHomeLocToSelfserviceCart = await selfServiceCantShowHomeLocDialog({
      price,
      firstDraw,
      lastDraw
    });
    if (addHomeLocToSelfserviceCart) {
      let weeks = CONSTANTS.DRAWS.NUMBER_OF_WEEKS;
      if (typeof addHomeLocToSelfserviceCart === 'object' && addHomeLocToSelfserviceCart.weeks) {
        weeks = addHomeLocToSelfserviceCart.weeks;
      }
      const data = {
        firstDraw,
        lastDraw,
        numberOfWeeks: weeks,
        product: 'Lyckoplatsen',
        primaryDraw,
        secondaryDraw,
        pinLocation: {
          lat: null,
          lng: null
        },
        lyckoplatsenName: getDefaultLocationName(),
        pinLocationType: CONSTANTS.LOCATION_TYPES.HOME,
        charityId: charity === null || charity === void 0 ? void 0 : charity.charityId
      };
      return makePayment({
        data,
        onDone: () => {
          setTimeout(() => {
            resetPlayAtom();
            svs.utils.url.navigate(svs.core.urlMapping.get('startPage'));
          }, 300);
        }
      });
    }
  };
  return handler;
};
setGlobal('svs.lyckoplatsen.components.page_play.react.hooks', {
  useHomeLocationSelfService
});

 })(window);